import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/home/ubuntu/python-project/production/apk_builder/downloads/69181a9adecb250014156b83/phonefix_pro_1763187354271/src/contexts/AuthContext.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/python-project/production/apk_builder/downloads/69181a9adecb250014156b83/phonefix_pro_1763187354271/src/styles/index.css");
